import { Pipe, PipeTransform } from '@angular/core'
import { WorkOrdersQuoteStatus } from '@wm-front/admin/graphql'

@Pipe({
  name: 'workOrdersQuoteStatus',
  standalone: true,
})
export class WorkOrdersQuoteStatusPipe implements PipeTransform {
  /** Transform work order status into localised string
   * @returns {string}
   * @param {WorkOrdersQuoteStatus} value
   */
  public transform(value: WorkOrdersQuoteStatus): string {
    switch (value) {
      case WorkOrdersQuoteStatus.Refused:
        return $localize`:Info Value | Value for the rejected work order status @@workOrdersQuoteStatusPipeRefusedLabel:Refusé`
      case WorkOrdersQuoteStatus.Signed:
        return $localize`:Info Value | Value for the signed work order status @@workOrdersQuoteStatusPipeSignedLabel:Signé`
      case WorkOrdersQuoteStatus.ToSign:
        return $localize`:Info Value | Value for the to sign work order status @@workOrdersQuoteStatusPipeToSignLabel:À signer`
      case WorkOrdersQuoteStatus.Validation:
        return $localize`:Info Value | Value for the validation work order status @@workOrdersQuoteStatusPipeValidationLabel:En validation`
      default:
        return ''
    }
  }
}
